import api from './client';
import type { ApiResponse, ArquivoFormulario, CategoriaArquivo } from '@engenharia/shared';

export async function uploadArquivo(
  formularioId: number,
  categoria: CategoriaArquivo,
  file: File,
  onProgress?: (pct: number) => void
): Promise<{ id: number }> {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('categoria', categoria);

  const res = await api.post<ApiResponse<{ id: number }>>(
    `/formularios/${formularioId}/arquivos`,
    formData,
    {
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress: (e) => {
        if (e.total && onProgress) onProgress(Math.round((e.loaded * 100) / e.total));
      },
    }
  );
  return res.data.data!;
}

export async function listarArquivos(
  formularioId: number,
  categoria?: CategoriaArquivo
): Promise<ArquivoFormulario[]> {
  const params = categoria ? { categoria } : {};
  const res = await api.get<ApiResponse<ArquivoFormulario[]>>(
    `/formularios/${formularioId}/arquivos`,
    { params }
  );
  return res.data.data!;
}

export async function obterUrlDownload(arquivoId: number): Promise<string> {
  const res = await api.get<ApiResponse<{ url: string }>>(`/arquivos/${arquivoId}/url`);
  return res.data.data!.url;
}

export async function deletarArquivo(arquivoId: number): Promise<void> {
  await api.delete(`/arquivos/${arquivoId}`);
}
